
import filters from "@/mixins/filters"
import formValidation from "@/mixins/formValidation"
import { mapActions, mapGetters, mapMutations } from "vuex"
import checkboxManagerMixin from '@/mixins/checkboxManager';

export default {
  mixins: [formValidation, filters, checkboxManagerMixin],
  data() {
    return {
      once: true,
      isActive: false,
    };
  },
  computed: {
    ...mapGetters({
      settings: "settings/settings/settings",
      isNight: "settings/settings/isNight"
    }),
    imagePath() {
      return require(`~/assets/img/forms/form_bank_img.webp`);
    }
  },
  methods: {
    onFocus() {
      this.setFocusShowFixes(false);
    },
    onFocusOut() {
      setTimeout(() => {
        this.setFocusShowFixes(true);
      }, 1000);
    },
    checkForm() {
      if (this.form.name.value.length < 2) {
        this.form.name.valid = false;
        return false;
      }
      if (!this.form.phone.valid) {
        this.form.phone.valid = false;
        return false;
      }
      const checkboxesValid = this.validateCheckboxes();
      if (!checkboxesValid) {
        return false;
      }
      return true;
    },
    async submitForm() {
      if (this.checkForm()) {
        let formData = {
          chosen_car: {},
          type: "callback",
          client_name: this.form.name.value,
          client_phone: this.form.phone.value
        };

        // utm
        if (localStorage.utm_source) {
          formData.utm_source = localStorage.utm_source;
        }
        if (localStorage.utm_medium) {
          formData.utm_medium = localStorage.utm_medium;
        }
        if (localStorage.utm_campaign) {
          formData.utm_campaign = localStorage.utm_campaign;
        }
        if (localStorage.utm_term) {
          formData.utm_term = localStorage.utm_term;
        }
        if (localStorage.utm_content) {
          formData.utm_content = localStorage.utm_content;
        }
        await this.sendForm(formData);
        await this.closeModal();
      }
    },
    windowScroll() {
      if (this.once) {
        this.once = false;
        setTimeout(() => {
          this.isActive = true;
        }, 4000);
      } else {
        return false;
      }
    },
    ...mapActions({
      openModal: "modal/modal-main/openModal",
      sendForm: "form/form/sendForm",
      closeModal: "modal/modal-main/closeModal"
    }),
    ...mapMutations({
      setFocusShowFixes: "car/car/SET_FOCUS_SHOW_FIXED"
    })
  }
};
